import React, {Component} from 'react';
const hocAddProps = (ParentComponent, np) => {
  return class extends Component {
    render () {
      const newProps = np;
      return <ParentComponent {...this.props} {...newProps} />;
    }
  }
}

export {hocAddProps};


// WEBPACK FOOTER //
// ./src/AntD/hoc/hocComponent.js